import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: 'form-layouts.html'
})
export class FormLayoutsComponent implements OnInit {

    ngOnInit() {
        
    }
}
